import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {HeadlineH1, HeadlineH2} from './text/Headlines';
import ActionButtonRow from '../components/ActionButtonRow';
import ErrorMessage from '../components/ErrorMessage';
import styled from 'styled-components';
import convertErrors from '../helpers/errorHelper';
import DeviceList from './DeviceList';
import LogList from './LogList';

const TableHeading = styled(HeadlineH2)`
  margin-top: 30px;
  margin-bottom: -40px;
`;

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {device: undefined};
  }

  componentWillReceiveProps = newProps => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    }
  };

  _goBackToList = () => this.props.history.replace('/users');

  _renderButtons = () => (
    <ActionButtonRow>
      <FlatButton onClick={this._goBackToList} label="Zurück zur Übersicht" />
      <FlatButton
        primary
        onClick={() => this.props.history.push('/user/' + this.props.match.params.id)}
        label="Benutzer bearbeiten"
      />
    </ActionButtonRow>
  );

  _renderToggleDeviceBlockingDialog() {
    let {
      state: {device},
      props: {toggleDeviceBlocking},
    } = this;
    const {_id, active, name} = device || {};
    return (
      <Dialog
        title={`Gerät ${active ? 'sperren' : 'entsperren'}`}
        modal
        open={!!device}
        actions={[
          <FlatButton label="Abbrechen" onClick={() => this.setState({device: undefined})} />,
          <FlatButton
            label={`Ja, Gerät ${active ? 'sperren' : 'entsperren'}`}
            primary
            onClick={() => {
              toggleDeviceBlocking(_id).catch(this._showErrors);
              this.setState({device: undefined});
            }}
          />,
        ]}>
        <div>
          Das Gerät {name} wird {active ? 'gesperrt' : 'entsperrt'}.<br />
          Zukünftiges Anmelden mit dem Gerät ist {active ? 'nicht mehr' : 'wieder'} möglich.
          <br />
          <br />
          Sind Sie sich wirklich sicher?
        </div>
      </Dialog>
    );
  }

  _showErrors = rawErrors => {
    let errors = convertErrors(rawErrors);
    this.setState({errors});
    console.log('there was an error sending the sos mutation', errors);
  };

  render() {
    let {name, devices, logs} = this.props.data.user || {};
    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        <HeadlineH1>Logs - {name}</HeadlineH1>
        {devices && devices.length > 0 && (
          <div>
            <TableHeading>Geräte</TableHeading>
            <DeviceList devices={devices} toggleDeviceBlocking={device => this.setState({device})} />
          </div>
        )}
        {logs && logs.length > 0 && (
          <div>
            <TableHeading>Logs</TableHeading>
            <LogList logs={logs} toggleDeviceBlocking={device => this.setState({device})} />
          </div>
        )}
        {this._renderButtons()}
        {this._renderToggleDeviceBlockingDialog()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Logs.js